import {Component, QueryList, ViewChildren} from '@angular/core';
import {AlertController, ModalController, NavController, NavParams, Select} from 'ionic-angular';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ReportService } from "../../services/report.service";
import { SuperTabsController } from "../../components/ionic2-super-tabs/src";
import { ReportSearchLocationPage } from "../report-search-location/report-search-location";
import { InfoModalPage } from "../info-modal/info-modal";
import {ApiService} from "../../services/api.service";
import {ReportSearchCustomerPage} from "../report-search-customer/report-search-customer";

@Component({
  selector: 'page-report-customer-client',
  templateUrl: 'report-customer-client.html'
})
export class ReportCustomerClientPage {

  @ViewChildren(Select) ionSelects: QueryList<Select>;

  data: any;
  locationExpanded = false;
  clientForm: FormGroup;
  locationForm: FormGroup;
  invoiceForm: FormGroup;
  externalForm: FormGroup;
  allowLocationSearch = true;
  showFooter = false;

  /**
   * clientRequiresAction
   * 0 = not selected
   * 1 = Bestaande klant
   * 2 = Nieuwe klant
   */
  clientRequiresAction = '0';

  clientFormDisabled = false;
  locationFormDisabled = false;

  invoiceExpanded = false;
  externalExpanded = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public superTabsCtrl: SuperTabsController,
    public reportService: ReportService,
    public apiService: ApiService
  ) {
    this.initForm();
  }

  initForm(){
    this.data = this.reportService.getData();
    if(this.data.workorder_id){
      this.allowLocationSearch = false;
      this.data._customer_status = 1; // Bestaande klant
    }

    if(!this.data.customers) this.data.customers = {};
    let has_data = (this.data.customers.client != null);
    if(!this.data.customers.client) this.data.customers.client = {};
    if(!this.data.customers.client._requires_action && this.data.customers.client.customer_id) this.data.customers.client._requires_action = '1';
    this.clientFormDisabled = (this.data.customers.client && this.data.customers.client._requires_action == '0');
    this.clientRequiresAction = (this.data.customers.client._requires_action ? this.data.customers.client._requires_action : '0');

    this.clientForm = this.formBuilder.group({
      _requires_action: new FormControl((has_data ? this.data.customers.client._requires_action : '2')),
      type: new FormControl((has_data ? this.data.customers.client.type : '1')),
      firstname: new FormControl((has_data ? this.data.customers.client.firstname : '')),
      lastname: new FormControl((has_data ? this.data.customers.client.lastname : ''), Validators.required),
      email: new FormControl((has_data ? this.data.customers.client.email : ''), Validators.compose([Validators.email, Validators.required])),
      phone: new FormControl((has_data ? this.data.customers.client.phone : '')),
      mobile: new FormControl((has_data ? this.data.customers.client.mobile : '')),
      mobile2: new FormControl((has_data ? this.data.customers.client.mobile2 : '')),
      preferred_contact_method: new FormControl((has_data ? this.data.customers.client.preferred_contact_method : 'email')),
      street: new FormControl((has_data ? this.data.customers.client.street : ''), Validators.required),
      number: new FormControl((has_data ? this.data.customers.client.number : ''), Validators.required),
      letter: new FormControl((has_data ? this.data.customers.client.letter : '')),
      zipcode: new FormControl((has_data ? this.data.customers.client.zipcode : ''), Validators.required),
      city: new FormControl((has_data ? this.data.customers.client.city : ''), Validators.required),
      country: new FormControl((has_data && this.data.customers.client.country ? this.data.customers.client.country : 'NL')),
      older_than_ten_years: new FormControl((has_data ? this.data.customers.client.older_than_ten_years : '')),
      tax_code: new FormControl((has_data ? this.data.customers.client.tax_code : '')),
      company: new FormControl((has_data ? this.data.customers.client.company : '')),
      notes: new FormControl((has_data ? this.data.customers.client.notes : '')),
      kvk: new FormControl((has_data ? this.data.customers.client.kvk : '')),
      vat_nr: new FormControl((has_data ? this.data.customers.client.vat_nr : '')),
      customer_nr: new FormControl((has_data ? this.data.customers.client.customer_nr : ''))
    });

    this.clientForm.get('_requires_action').valueChanges.subscribe(() => {
      if(this.clientForm.get('_requires_action').value == '0'){
        this.clientFormDisabled = true;
      } else {
        this.clientFormDisabled = false;
      }
    });

    // Location
    has_data = (this.data.location != null);
    if(!this.data.location) this.data.location = {};
    if(this.data.location._requires_action == null && this.data.location.location_id) this.data.location._requires_action = '0';
    if(this.data.location._same_as_client == null){
      if(this.data.location.location_id) this.data.location._same_as_client = 0;
      else this.data.location._same_as_client = 1;
    }
    this.locationExpanded = (this.data.location._same_as_client == 0);
    this.locationFormDisabled = (this.data.location._requires_action == '0');
    this.locationForm = this.formBuilder.group({
      _requires_action: new FormControl((has_data ? this.data.location._requires_action : '2')),
      street: [(has_data ? this.data.location.street : ''), Validators.required],
      number: [(has_data ? this.data.location.number : ''), Validators.required],
      letter: [(has_data ? this.data.location.letter : '')],
      zipcode: [(has_data ? this.data.location.zipcode : ''), Validators.required],
      city: [(has_data ? this.data.location.city : ''), Validators.required],
      country: [(has_data && this.data.location.country ? this.data.location.country : 'NL')],
      older_than_ten_years: [(has_data && this.data.location.older_than_ten_years ? this.data.location.older_than_ten_years : '')]
    });

    this.locationForm.get('_requires_action').valueChanges.subscribe(() => {
      if(this.locationForm.get('_requires_action').value == '0'){
        this.locationFormDisabled = true;
      } else {
        this.locationFormDisabled = false;
      }
      /* Locatie velden leegmaken? alert */
      if(this.locationForm.get('_requires_action').value == '2'){
        this.alertCtrl.create({
          title: 'Nieuwe locatie',
          message: 'Wilt u de ingevulde gegevens wissen?',
          buttons: [
            {
              text: 'Ja',
              handler: () => {
                this.locationForm.get('street').setValue('');
                this.locationForm.get('number').setValue('');
                this.locationForm.get('letter').setValue('');
                this.locationForm.get('zipcode').setValue('');
                this.locationForm.get('city').setValue('');
                this.locationForm.get('older_than_ten_years').setValue('');
              }
            },{
              text: 'Nee',
              role: 'cancel'
            }
          ]
        }).present();
      }
    });

    // Invoice
    if(this.data.customers.invoice && this.data.customers.invoice._same_as_client == null) this.data.customers.invoice._same_as_client = 0;
    this.invoiceExpanded = (this.data.customers.invoice && this.data.customers.invoice._same_as_client === 0);
    has_data = (this.data.customers.invoice != null);
    if(this.data.customers.invoice && this.data.customers.invoice.customer_id && !this.data.customers.invoice._requires_action){
      this.data.customers.invoice._requires_action = '1';
    }
    this.invoiceForm = this.formBuilder.group({
      _requires_action: new FormControl((has_data ? this.data.customers.invoice._requires_action : '2')),
      company: [(has_data ? this.data.customers.invoice.company : '')],
      notes: [(has_data ? this.data.customers.invoice.notes : '')],
      type: [(has_data ? this.data.customers.invoice.type : '1')],
      firstname: [(has_data ? this.data.customers.invoice.firstname : '')],
      lastname: [(has_data ? this.data.customers.invoice.lastname : '')],
      email: [(has_data ? this.data.customers.invoice.email : ''), Validators.email],
      phone: [(has_data ? this.data.customers.invoice.phone : '')],
      mobile: [(has_data ? this.data.customers.invoice.mobile : '')],
      mobile2: [(has_data ? this.data.customers.invoice.mobile2 : '')],
      preferred_contact_method: [(has_data ? this.data.customers.invoice.preferred_contact_method : 'email')],
      street: [(has_data ? this.data.customers.invoice.street : ''), Validators.required],
      number: [(has_data ? this.data.customers.invoice.number : ''), Validators.required],
      letter: [(has_data ? this.data.customers.invoice.letter : '')],
      zipcode: [(has_data ? this.data.customers.invoice.zipcode : ''), Validators.required],
      city: [(has_data ? this.data.customers.invoice.city : ''), Validators.required],
      country: [(has_data && this.data.customers.invoice.country ? this.data.customers.invoice.country : 'NL'), Validators.required],
      older_than_ten_years: new FormControl((has_data ? this.data.customers.invoice.older_than_ten_years : '')),
      tax_code: new FormControl((has_data ? this.data.customers.invoice.tax_code : '')),
      kvk: [(has_data ? this.data.customers.invoice.kvk : '')],
      vat_nr: [(has_data ? this.data.customers.invoice.vat_nr : '')]
    });

    // External
    if(this.data.customers.external && this.data.customers.external._same_as_client == null) this.data.customers.external._same_as_client = 0;
    this.externalExpanded = (this.data.customers.external && this.data.customers.external._same_as_client === 0);
    has_data = (this.data.customers.external != null);
    if(this.data.customers.external && this.data.customers.external.customer_id && !this.data.customers.external._requires_action){
      this.data.customers.external._requires_action = '1';
    }
    this.externalForm = this.formBuilder.group({
      _requires_action: new FormControl((has_data ? this.data.customers.external._requires_action : '2')),
      company: [(has_data ? this.data.customers.external.company : '')],
      notes: [(has_data ? this.data.customers.external.notes : '')],
      type: [(has_data ? this.data.customers.external.type : '1')],
      firstname: [(has_data ? this.data.customers.external.firstname : '')],
      lastname: [(has_data ? this.data.customers.external.lastname : '')],
      email: [(has_data ? this.data.customers.external.email : ''), Validators.compose([Validators.email, Validators.required])],
      phone: [(has_data ? this.data.customers.external.phone : '')],
      mobile: [(has_data ? this.data.customers.external.mobile : '')],
      mobile2: [(has_data ? this.data.customers.external.mobile2 : '')],
      preferred_contact_method: [(has_data ? this.data.customers.external.preferred_contact_method : 'email')],
      street: [(has_data ? this.data.customers.external.street : ''), Validators.required],
      number: [(has_data ? this.data.customers.external.number : ''), Validators.required],
      letter: [(has_data ? this.data.customers.external.letter : '')],
      zipcode: [(has_data ? this.data.customers.external.zipcode : ''), Validators.required],
      city: [(has_data ? this.data.customers.external.city : ''), Validators.required],
      country: [(has_data && this.data.customers.external.country ? this.data.customers.external.country : 'NL'), Validators.required],
      older_than_ten_years: new FormControl((has_data ? this.data.customers.external.older_than_ten_years : '')),
      tax_code: new FormControl((has_data ? this.data.customers.external.tax_code : '')),
      kvk: [(has_data ? this.data.customers.external.kvk : '')],
      vat_nr: [(has_data ? this.data.customers.external.vat_nr : '')]
    });
  }

  ionViewDidEnter() {
    console.log('ReportCustomerClientPage: ionViewDidEnter');
    // Translate ion-select fix
    this.fixIonSelects();
    // iOS footer display fix
    this.showFooter = false;
    setTimeout(() => {
      this.showFooter = true;
    }, 100);
  }

  ionViewDidLeave(){
    console.log('ReportCustomerClientPage: ionViewDidLeave');
    this.save();
  }

  setNewCustomer(){
    this.data.customers.client._requires_action = 2;
    this.data.location._requires_action = 2;
    this.clientRequiresAction = '2';
    // Translate ion-select fix
    this.fixIonSelects();
  }

  fixIonSelects(){
    // Translate ion-select fix
    setTimeout(() => {
      if (this.ionSelects) this.ionSelects.map((select) => select._inputUpdated());
    }, 250);
  }

  isValid(){
    if(
        this.clientForm.valid &&
        (this.locationForm.valid || !this.locationExpanded) &&
        (this.invoiceForm.valid || !this.invoiceExpanded) &&
        (this.externalForm.valid || !this.externalExpanded)
    ){
      return true;
    }
    return false;
  }

  save(){
    this.clientForm.markAsTouched();
    this.locationForm.markAsTouched();
    this.invoiceForm.markAsTouched();
    this.externalForm.markAsTouched();

    if(this.isValid()){
      this.superTabsCtrl.setColor('reportCustomerClientPage', 'tab_ok', 'mainTabs');
      this.data._valid.reportCustomerClientPage = 1;
    } else {
      this.superTabsCtrl.setColor('reportCustomerClientPage', 'tab_error', 'mainTabs');
      this.data._valid.reportCustomerClientPage = -1;
    }

    /* save client */
    if(!this.data.customers) this.data.customers = {};
    if(!this.data.customers.client) this.data.customers.client = {};
    Object.assign(this.data.customers.client, this.clientForm.value);

    /* save location */
    let location = this.data.location ? this.data.location : {};
    Object.assign(location, this.clientForm.value);
    location._same_as_client = (this.locationExpanded ? 0 : 1);
    this.data.location = location;

    /* save invoice */
    if(!this.data.customers.invoice) this.data.customers.invoice = {};
    Object.assign(this.data.customers.invoice, this.invoiceForm.value);
    this.data.customers.invoice._same_as_client = (this.invoiceExpanded ? 0 : 1);

    /* save external */
    if(!this.data.customers.external) this.data.customers.external = {};
    Object.assign(this.data.customers.external, this.externalForm.value);
    this.data.customers.external._same_as_client = (this.externalExpanded ? 0 : 1);

    this.reportService.setData(this.data);
  }

  confirm(){
    this.save();
    this.reportService.save().then(() => {
      this.superTabsCtrl.slideTo('reportWorkorderPage', 'mainTabs');
    });
  }

  public searchAddress(){
    this.modalCtrl.create(ReportSearchLocationPage, {
      clientForm: this.clientForm,
      locationForm: this.locationForm,
      invoiceForm: this.invoiceForm,
      externalForm: this.externalForm,
      page: this,
      data: this.data
    }).present();
  }

  public searchExternalCustomer(){
    this.modalCtrl.create(ReportSearchCustomerPage, {
      clientForm: this.clientForm,
      locationForm: this.locationForm,
      invoiceForm: this.invoiceForm,
      externalForm: this.externalForm,
      page: this,
      data: this.data
    }).present();
  }

  public openInfo(title, text){
    this.modalCtrl.create(InfoModalPage, {
      title: title,
      text: text
    }).present();
  }

  public getAddressByPostcode(form: FormGroup){
    if (form.get('country').value == 'NL' && form.get('zipcode').value && form.get('number').value && !form.get('street').value && !form.get('city').value) {
      this.apiService.getAddressByPostcode(form.get('zipcode').value, form.get('number').value, form.get('letter').value).then((result: any) => {
        console.log(result);
        if(result.city){
          form.get('city').setValue(result.city);
        }
        if(result.street){
          form.get('street').setValue(result.street);
        }
      }).catch((error) => {
        console.error(error);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-customer-client/report-customer-client.ts